<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/order/details/', projectId, orderId]">Zurück zum Angebot</a>
    </li>
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/orders']">Übersicht</a>
    </li>
  </ul>
</nav>

<main>
  <h2 class="mb1em">PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Transportschein {{ projectId }}.0005.{{ transportId }} bearbeiten</h2>
  <app-order-transport-form
    *ngIf="transport"
    [projectId]="projectId"
    [orderId]="orderId"
    [transportId]="transportId"
    [jobId]="jobId"
    [transportData]="transport[0]"
    [isUpdateMode]="true">
  </app-order-transport-form>
</main>

<pre *ngIf="devMode" class="datepicker-output">
  <p>Transport:</p>
  {{ transport | json }}
</pre>
